<template>
  <div class="app-right-main">
    <el-dialog
      title="兑换码生成"
      :visible.sync="dVisible"
      @close="dVisible = false"
      width="350px"
      :append-to-body="true"
    >
      <el-form
        :model="mForm"
        ref="mForm"
        :rules="mRules"
        size="mini"
        label-width="90px"
      >
        <el-form-item label="会员内容" prop="vip_id">
          <el-select
            v-model="mForm.vip_id"
            placeholder="请选择"
            clearable
            style="width: 200px"
          >
            <el-option
              v-for="(v, k) in vipMap"
              :key="k"
              :label="v.content"
              :value="k"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="数量" prop="generate_num">
          <el-input-number
            v-model="mForm.generate_num"
            style="width: 200px"
            :step="10"
            :min="1"
            :max="1000"
          ></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button @click="dVisible = false">取消</el-button>
          <el-button type="primary" @click="redeemCreate">创建</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-row class="searchRow">
      <el-col :span="22">
        <!-- 查询框区域 -->
        <el-form
          :model="searchForm"
          size="mini"
          :inline="true"
          label-width="90px"
        >
          <el-form-item label="兑换码" prop="keyword">
            <el-input
              v-model="searchForm.keyword"
              clearable
              placeholder="请输入兑换码"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select
              v-model="searchForm.status"
              placeholder="请选择"
              clearable
              style="width: 14vw"
            >
              <el-option
                v-for="(v, k) in statusMap"
                :key="k"
                :label="v"
                :value="k"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="会员内容" prop="vip">
            <el-select
              v-model="searchForm.vip"
              placeholder="请选择"
              clearable
              style="width: 14vw"
            >
              <el-option
                v-for="(v, k) in vipMap"
                :key="k"
                :label="v.content"
                :value="k"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-col :span="22">
            <el-form-item label="生成时间" prop="createdAt">
              <el-date-picker
                clearable
                v-model="searchForm.createdAt"
                type="daterange"
                :value-format="'yyyy-MM-dd'"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="兑换时间" prop="exchangeTime">
              <el-date-picker
                clearable
                v-model="searchForm.exchangeTime"
                type="daterange"
                :value-format="'yyyy-MM-dd'"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-form>
      </el-col>

      <!-- 提交按钮 -->
      <el-col :span="2" class="searchbuttons">
        <div>
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-search"
            @click="init()"
            >查询</el-button
          >
        </div>
        <div class="searchButton">
          <el-button
            type="info"
            size="mini"
            icon="el-icon-refresh-right"
            @click="reset"
            >重置</el-button
          >
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <el-button
          type="primary"
          icon="el-icon-download"
          size="small"
          @click="download"
          v-permission="'down_redeem'"
          >下载</el-button
        >
      </el-col>
      <el-col :span="12" style="text-align: right">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="small"
          @click="dVisible = true"
          v-permission="'creat_redeem'"
          >生成</el-button
        >
      </el-col>
    </el-row>
    <div style="padding: 10px 0">
      <el-tag style="margin-right: 5px"> 总数：{{ totalData.total }} </el-tag>
      <el-tag style="margin-right: 5px"> 作废：{{ totalData.zf }} </el-tag>
      <el-tag style="margin-right: 5px"> 已兑换：{{ totalData.ydh }} </el-tag>
      <el-tag style="margin-right: 5px"> 兑换率：{{ totalData.dhl }} %</el-tag>
    </div>
    <el-table
      :data="tbList"
      size="small"
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column align="left" prop="_id" label="序号" width="80">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        prop="exchangeVip"
        label="会员"
        min-width="100"
      >
        <template slot-scope="scope">
          {{
            vipMap[
              `${scope.row.exchangeVip ?? ""}-${scope.row.exchangeSubVip ?? ""}`
            ]?.name
          }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        prop="exchangeSubVip"
        label="会员内容"
        min-width="150"
      >
        <template slot-scope="scope">
          {{
            vipMap[
              `${scope.row.exchangeVip ?? ""}-${scope.row.exchangeSubVip ?? ""}`
            ]?.content
          }}
        </template>
      </el-table-column>
      <el-table-column align="left" prop="code" label="兑换码" min-width="150">
        <template slot-scope="scope">
          <span style="color: #165dff">
            {{ scope.row.code }}
          </span>
        </template>
      </el-table-column>

      <el-table-column
        align="left"
        prop="createdAt"
        label="生成日期"
        min-width="150"
      ></el-table-column>

      <el-table-column
        align="left"
        prop="buildMethod"
        label="创建方式"
        min-width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.buildMethod === "1" ? "系统生成（邮件）" : "手动生成" }}
        </template>
      </el-table-column>

      <el-table-column
        align="left"
        prop="exchangeTime"
        label="兑换时间"
        min-width="150"
      ></el-table-column>
      <el-table-column align="left" prop="un" label="用户" width="120">
        <template slot-scope="scope">
          <router-link
            :to="{
              path: '/userDetail',
              query: {
                id: scope.row.uid,
                tabs: 'first',
              },
            }"
          >
            {{ scope.row.un }}
          </router-link>
        </template>
      </el-table-column>
      <el-table-column align="left" prop="status" label="状态" width="80">
        <template slot-scope="scope">
          {{ statusMap[scope.row.status] }}
        </template>
      </el-table-column>
      <el-table-column
        v-if="$jumpPerm('del_redeem')"
        align="center"
        fixed="right"
        label="操作"
        width="120"
      >
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.status === 1"
            @click="repeal(scope)"
            type="text"
            size="small"
          >
            作废
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="dial-pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[5, 10, 20, 50, 100, 200, 300, 400]"
        :page-size="size"
        layout="->,sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { exportToExcel } from "@/utils/util";
import { Message } from "element-ui";
import { redeemList, redeemRepeal, redeemAdd, vipAll } from "../../api/userApi";
import { handleResponse } from "../../utils/response";

export default {
  name: "Redeem",
  data() {
    return {
      statusMap: {
        1: "未兑换",
        2: "已兑换",
        3: "已作废",
      },
      searchForm: {},
      tbList: [],
      size: 10,
      page: 1,
      total: 0,
      loading: true,
      vipMap: {},
      dVisible: false,
      mForm: {
        vip_id: "",
        generate_num: 10,
      },
      mRules: {
        vip_id: [
          { required: true, message: "请选择会员内容", trigger: "change" },
        ],
        generate_num: [
          { required: true, message: "请输入数量", trigger: "change" },
        ],
      },
      totalData: { total: 0, ydh: 0, zf: 0, dhl: 0 },
    };
  },
  computed: {
    addRedeem() {
      return (
        this.$store.state.userInfo.permissions.includes("addRedeem") ||
        this.$store.getters.isAdmin
      );
    },
    downRedeem() {
      return (
        this.$store.state.userInfo.permissions.includes("downRedeem") ||
        this.$store.getters.isAdmin
      );
    },
  },
  created() {
    this.init(1, true);
    this.loadVips();
  },
  methods: {
    async loadRList() {
      const p = this.queryParams();

      const total = this.total;
      let ydh = 0;
      let zf = 0;

      if (p.status) {
        if (p.status === "2") {
          ydh = total;
        } else if (p.status === "3") {
          zf = total;
        }
      } else {
        const ydhRes = await redeemList({
          ...p,
          status: 2,
          page: 1,
          size: 1,
        });

        const zfRes = await redeemList({
          ...p,
          status: 3,
          page: 1,
          size: 1,
        });

        ydh = ydhRes.data?.data?.count ?? 0;
        zf = zfRes.data?.data?.count ?? 0;
      }

      const dhl = total > 0 ? ((ydh / total) * 100).toFixed(2) : 0;

      this.totalData = {
        total,
        ydh,
        zf,
        dhl,
      };
    },
    loadVips() {
      vipAll().then((res) => {
        handleResponse(
          res,
          (data) => {
            this.vipMap = (data.list || [])
              .map((v) => {
                if (v.subVipList?.length) {
                  return v.subVipList.map((s) => ({
                    ...s,
                    _id: v._id,
                    name: v.name,
                    content: s.name,
                  }));
                }
                return [v];
              })
              .flat()
              .reduce((m, n) => {
                m[`${n._id}-${n.type ?? ""}`] = n;
                return m;
              }, {});
          },
          (error) => {}
        );
      });
    },
    queryParams() {
      const { exchangeTime, createdAt, ...q } = this.searchForm;
      return {
        ...q,
        createdAt:
          createdAt?.length > 0
            ? createdAt
                .map((n, i) => n + " " + (i == 0 ? "00:00:00" : "23:59:59"))
                .join("~")
            : "",
        exchangeTime:
          exchangeTime?.length > 0
            ? exchangeTime
                .map((n, i) => n + " " + (i == 0 ? "00:00:00" : "23:59:59"))
                .join("~")
            : "",
      };
    },
    download() {
      redeemList({
        ...this.queryParams(),
        page: 1,
        size: 10000,
      }).then((res) => {
        handleResponse(
          res,
          (data) => {
            exportToExcel(
              data.list.map((n, i) => ({
                序号: i + 1,
                兑换码: n.code,
                会员:
                  this.vipMap[
                    `${n.exchangeVip ?? ""}-${n.exchangeSubVip ?? ""}`
                  ]?.name || "",
                会员内容:
                  this.vipMap[
                    `${n.exchangeVip ?? ""}-${n.exchangeSubVip ?? ""}`
                  ]?.content || "",
                生成时间: n.createdAt,
                创建方式:
                  n.buildMethod === "1" ? "系统生成（邮件）" : "手动生成",
                兑换时间: n.exchangeTime,
                用户: n.un ?? "",
                状态: this.statusMap[n.status],
              })),
              "兑换码"
            );
          },
          (error) => {
            this.loading = false;
          }
        );
      });
    },
    redeemCreate() {
      this.$refs["mForm"].validate((valid) => {
        if (valid) {
          redeemAdd({
            generate_num: this.mForm.generate_num,
            vip_id: this.mForm.vip_id,
          }).then((res) => {
            handleResponse(
              res,
              (data) => {
                Message.success("兑换码生成中...，请刷新查看！");
                this.dVisible = false;
              },
              (error) => {
                Message.error("兑换码生成失败");
              }
            );
          });
        } else {
          return false;
        }
      });
    },
    repeal(scope) {
      redeemRepeal({ _id: scope.row.id }).then((res) => {
        handleResponse(
          res,
          (data) => {
            Message.success("作废成功");
            scope.row.status = 3;
          },
          (error) => {
            Message.error("作废失败");
          }
        );
      });
    },
    init(page = 1, flag = false) {
      this.page = page;
      this.loading = true;
      redeemList({
        ...this.queryParams(),
        page,
        size: this.size,
      }).then((res) => {
        handleResponse(
          res,
          (data) => {
            this.tbList = data.list;
            this.total = data.count;
            this.loading = false;
            // if (flag) {
            this.loadRList();
            // }
          },
          (error) => {
            this.loading = false;
          }
        );
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.init();
    },
    handleCurrentChange(val) {
      this.init(val);
    },
    reset() {
      this.searchForm = {};
      this.init();
    },
  },
};
</script>
<style scoped></style>
